import React from 'react';
import { withStyles } from 'tss-react/mui';
import { AxlButton } from '../../../components/AxlButton';

export const TableButton = withStyles(AxlButton, {
  root: {
    minWidth: 'unset',
    padding: '4px 6px',
    marginLeft: '5px',
    marginTop: '5px',

    '&.bgDanger': {
      backgroundColor: '#d0021b',
      color: '#fff',
    },
    '&.bgPrimary': {
      backgroundColor: '#8192a7',
      color: '#fff',
    },
  },
});

const ActionButton = (props) => {
  const { id, name, username, userId, phoneNumber, bgStatus, handleRemove, handleApprove, handleResetPassword } = props;
  const status = bgStatus ? bgStatus.toUpperCase() : '';
  let isShowAprroved = true;
  if (['MANUAL_APPROVED', 'AUTO_APPROVED'].includes(status)) {
    isShowAprroved = false;
  }
  return (
    <>
      <TableButton
        variant="contained"
        className="bgDanger"
        onClick={(e) => {
          handleRemove(e, id, name);
        }}
      >
        {' '}
        Delete
      </TableButton>
      <TableButton
        variant="contained"
        className="bgPrimary"
        onClick={(e) => {
          handleResetPassword(e, id, name, username, phoneNumber, userId);
        }}
      >
        {' '}
        Reset Password
      </TableButton>
      {isShowAprroved && (
        <TableButton variant="contained" className="bgPrimary" onClick={(e) => handleApprove(e, id, name)}>
          {' '}
          Approve
        </TableButton>
      )}
    </>
  );
};

export default React.memo(ActionButton);
